import React, { useEffect, useState } from 'react';
import InquiryModal from '../../components/features/InquiryModal';
import CanvasText from '../../components/common/CanvasText';
import { getCompanyInfo } from '../../api/config';
import Card, { CardContent } from '../../components/ui/Card';

const Contact = () => {
    const [info, setInfo] = useState({
        email: 'hi@ggusol.com',
        phone: '010-5485-3991',
        addressDetail: '경기도 부천시 소사구 양지로 237, 9층 981호 (옥길동, 광양프런티어밸리 5차 지식산업센터)',
        name: '가까운솔루션',
    });

    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const data = await getCompanyInfo();
                if (data) {
                    setInfo(prev => ({ ...prev, ...data }));
                }
            } catch (err) {
                console.error('Failed to load contact info', err);
            }
        };
        fetchInfo();
    }, []);

    return (
        <div className="pb-24 bg-surface-bg min-h-screen">
            {/* Hero Section */}
            <div className="bg-primary-50 py-16 text-center border-b border-primary-100">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">문의하기</h1>
                    <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
                        궁금한 점이 있으신가요? 언제든 편하게 연락주세요.<br />
                        <span className="font-semibold text-primary-500">영업일 기준 4시간 이내, 최대 24시간 내에 답변드립니다.</span>
                    </p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 mt-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
                    {/* Info Side */}
                    <Card className="h-full">
                        <CardContent className="p-8 md:p-10">
                            <h2 className="text-2xl font-bold text-gray-900 mb-8 border-b border-gray-100 pb-4">연락처 정보</h2>

                            <div className="mb-8">
                                <span className="block text-sm font-bold text-primary-500 uppercase tracking-wider mb-2">Email</span>
                                <div className="inline-block text-xl font-medium text-gray-900">
                                    <CanvasText text={info.email} type="email" font="1.25rem Pretendard" />
                                </div>
                            </div>

                            <div className="mb-8">
                                <span className="block text-sm font-bold text-primary-500 uppercase tracking-wider mb-2">Phone / SMS</span>
                                <div className="inline-block text-xl font-medium text-gray-900">
                                    <CanvasText text={info.phone} type="tel" font="1.25rem Pretendard" />
                                </div>
                                <p className="text-sm text-gray-500 mt-2 bg-gray-50 p-3 rounded-lg border border-gray-100">
                                    <span className="text-primary-500 mr-2">📌</span>부재 시 문자를 남겨주시면 확인 후 연락드립니다.
                                </p>
                            </div>

                            <div className="mb-8">
                                <span className="block text-sm font-bold text-primary-500 uppercase tracking-wider mb-2">Office</span>
                                <div className="text-lg leading-relaxed text-gray-800">
                                    <CanvasText text={info.addressDetail} font="1.1rem Pretendard" type="copy" />
                                    <br />
                                    <CanvasText text={info.name} font="1.1rem Pretendard" type="copy" />
                                </div>
                            </div>

                            {/* Quick Inquiry Form */}
                            <div className="mt-12 pt-8 border-t border-gray-100">
                                <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center">
                                    <span className="w-2 h-6 bg-primary-500 rounded-sm mr-3"></span>
                                    빠른 문의 작성
                                </h3>
                                {/* Inline Modal logic preserved directly */}
                                <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                                    <InquiryModal inline type="CONTACT" />
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    {/* Map Side */}
                    <Card className="h-full min-h-[500px] overflow-hidden">
                        <iframe
                            title="가까운솔루션 위치"
                            src="https://maps.google.com/maps?q=%EA%B2%BD%EA%B8%B0%EB%8F%84%20%EB%B6%80%EC%B2%9C%EC%8B%9C%20%EC%86%8C%EC%82%AC%EA%B5%AC%20%EC%96%91%EC%A7%80%EB%A1%9C%20237%20%EA%B4%91%EC%96%91%ED%94%84%EB%9F%B0%ED%8B%B0%EC%96%B4%EB%B0%B8%EB%A6%AC%205%EC%B0%A8&t=&z=15&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="100%"
                            className="border-0 w-full h-full min-h-[400px] lg:min-h-full"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Contact;
